import AppSystemWebApiResourceModel from '../../generated/types/model/resource/AppSystemWebApiResourceModel';

export default class AppSystemWebApiResourceViewModel extends AppSystemWebApiResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
